var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "6w8sgoe19a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.537255 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pl144xboub",
    d: "M0 0L18.529 0 18.529 18.529 0 18.529z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#6w8sgoe19a)",
    transform: "translate(-199 -726)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199 726) translate(1.235 1.235)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j3byp1jaoc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pl144xboub"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.265 16.677c-4.095 0-7.412-3.317-7.412-7.412S5.17 1.853 9.265 1.853s7.411 3.317 7.411 7.412-3.316 7.412-7.411 7.412M9.255 0C4.141 0 0 4.15 0 9.265c0 5.114 4.141 9.265 9.255 9.265 5.124 0 9.274-4.151 9.274-9.265C18.53 4.15 14.38 0 9.255 0",
    mask: "url(#j3byp1jaoc)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.728 4.632L8.338 4.632 8.338 10.191 13.202 13.109 13.897 11.97 9.728 9.496z",
    transform: "translate(199 726) translate(1.235 1.235)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.83592e174701e5fe30ba18fb5f227157.svg";
export { ForwardRef as ReactComponent };